module.exports = __webpack_public_path__ + "img/btn_close_white.fb443a29.svg";